import React, { useEffect, useRef, useState } from "react";
import "@google/model-viewer";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import MyCustomRain from "./components/Landing/MyCustomRain";
import Landing from "./components/Landing/Landing";

const App = () => {
  const [showRain, setShowRain] = useState(true);
  const [fadeOut, setFadeOut] = useState(false); // New state for fade-out effect
  const beeRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setShowRain(false);
      }, 2000); // Duration for rain fade-out
    }, 10000); // Duration to show rain before fade-out
    return () => clearTimeout(timer);
  }, [fadeOut]); // Add fadeOut to the dependency array

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const beeElement = beeRef.current;

      if (!beeElement) return;

      const sectionPositions = [
        { top: "55%", left: "10%" },
        { top: "20%", left: "10%" },
        { top: "30%", left: "10%" },
        { top: "40%", left: "70%" },
        { top: "40%", left: "50%" },
        { top: "40%", left: "30%" },
        { top: "40%", left: "70%" },
        { top: "30%", left: "80%" },
        { top: "20%", left: "90%" },
        { top: "40%", left: "20%" },
        { top: "50%", left: "8%" },
        { top: "70%", left: "30%" },
        { top: "20%", left: "20%" },
        { top: "80%", left: "10%" },
        { top: "10%", left: "90%" },
        { top: "40%", left: "30%" },
      ];

      const sectionHeight = 700;
      const currentSectionIndex = Math.floor(scrollPosition / sectionHeight);
      const nextSectionIndex = currentSectionIndex + 1;

      const currentPosition =
        sectionPositions[
          Math.min(currentSectionIndex, sectionPositions.length - 1)
        ];
      const nextPosition =
        sectionPositions[
          Math.min(nextSectionIndex, sectionPositions.length - 1)
        ];

      const progress = (scrollPosition % sectionHeight) / sectionHeight;

      const interpolate = (start, end) =>
        parseFloat(start) + (parseFloat(end) - parseFloat(start)) * progress;

      const top = interpolate(currentPosition.top, nextPosition.top) + "%";
      const left = interpolate(currentPosition.left, nextPosition.left) + "%";

      const rotatingSections = [3, 9, 11, 13];
      const enlargedSections = [2, 8, 14];

      let transformStyle = "translate(-50%, -50%)";
      if (rotatingSections.includes(currentSectionIndex)) {
        transformStyle += " rotate(360deg)";
      }
      if (enlargedSections.includes(currentSectionIndex)) {
        transformStyle = "scale(2) " + transformStyle;
      }

      beeElement.style.transform = transformStyle;
      beeElement.style.top = top;
      beeElement.style.left = left;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
  {showRain ? 
      <div className={`rain-container ${fadeOut ? "fade-out" : ""}`}>
        <MyCustomRain
          numImages={20}
          imageSrc={"/assets/images/capsule-1.svg"}
        />
      </div>
    :
      <div className={`landing-content ${fadeOut ? "fade-in" : ""}`}>
        <Landing />
      </div>
    }
    </>
  );
};

export default App;
